export function showSiteTypeChangingReducer(state: boolean = false): boolean {
  return state;
}
